import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axiosConfig';

const FacilityListPage = () => {
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        const response = await api.get('/facilities');
        setFacilities(response.data);
        setLoading(false);
      } catch (err) {
        setError('시설 목록을 불러오는데 실패했습니다.');
        console.error('Error fetching facilities:', err);
        setLoading(false);
      }
    };
    fetchFacilities();
  }, []);

  if (loading) {
    return <div className="text-center p-5"><div className="spinner-border text-primary" role="status"></div></div>;
  }

  return (
    <div className="pb-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold mb-1">시설 관리</h4>
          <p className="text-muted mb-0 small">등록된 시설을 관리하고 새로운 시설을 추가합니다.</p>
        </div>
        <Link to="/facilities/new" className="btn btn-primary rounded-3 px-3 fw-bold">
          <i className="bi bi-plus-lg text-white me-1"></i>
          <span className="d-none d-md-inline">시설 등록</span>
        </Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {facilities.length > 0 ? (
        <div className="row g-3">
          {facilities.map(facility => (
            <div className="col-md-6 col-lg-4" key={facility.id}>
              {/* 아이콘만 한 줄, 이름 한 줄, 단추 한 줄로 쌓아 두어 오른쪽이
                  비어 있었다. 이름을 아이콘 옆에 두고 단추를 점 세 개 옆으로
                  올리면 같은 내용이 두 줄에 들어간다. */}
              <div className="card h-100 border-0 shadow-sm hover-shadow transition-base">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center gap-2">
                    <div className="bg-primary bg-opacity-10 p-2 rounded-3 text-primary lh-1">
                      <i className="bi bi-building"></i>
                    </div>
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                      <div className="fw-bold text-truncate">{facility.name}</div>
                      {/* 주소가 비어 있으면 핀만 덩그러니 남는다. */}
                      {facility.address && (
                        <div className="text-muted text-truncate" style={{ fontSize: '0.75rem' }}>
                          <i className="bi bi-geo-alt me-1"></i>
                          {facility.address}
                        </div>
                      )}
                    </div>
                    <Link
                      to={`/facilities/${facility.id}`}
                      className="btn btn-sm btn-outline-primary rounded-pill px-3 text-nowrap"
                    >
                      상세
                    </Link>
                    <div className="dropdown">
                      <button className="btn btn-link text-muted p-0 px-1" type="button" data-bs-toggle="dropdown">
                        <i className="bi bi-three-dots-vertical"></i>
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm">
                        <li><Link className="dropdown-item" to={`/facilities/${facility.id}/update`}>수정</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center p-5 card border-0 shadow-sm">
          <div className="mb-3 text-muted">
            <i className="bi bi-building-add" style={{ fontSize: '3rem' }}></i>
          </div>
          <h5 className="text-muted">등록된 시설이 없습니다.</h5>
          <p className="text-muted small">새로운 시설을 등록하여 관리를 시작하세요.</p>
        </div>
      )}
    </div>
  );
};

export default FacilityListPage;
